import React from 'react';

import {LoadingLine} from 'app/general/loading/LoadingLine';

export function LoadingList() {
  return (
    <ul className="list-group">
      {[87, 80, 94, 70, 90].map((width, index) => (
        <li className="list-group-item" key={index}>
          <LoadingLine width={`${width}%`} height="1.2rem" />
        </li>
      ))}
    </ul>
  );
}
